<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "认证服务",
            items: [],
            loading: false,
            userinfo: {},
            appid: "",
            micoapplist: {},
            micoappauth: {
                customer_type: "",
                contact_info: {
                    name: "",
                    email: "",
                    mobile: "",
                },
                qualification: "",
                account_name: "",
                account_name_type: "1",
                auth_identification: "",
                auth_ident_material: "",
            },
            uploadingimg: {
                micoappauth_upload: "",
            },
            trademarkPreviews: ["", "", "", "", ""],
            trademarkMediaIds: ["", "", "", "", ""],
            trademarkUploading: [false, false, false, false, false],
            micoappauthpaper: false,
            micoappauth_agree: true,
            authSubmitLoading: false,
            authQrcodeDialogVisible: false,
            authQrcodeDataUrl: "",
            isUploadingAuth: false,
            authQuery: null,
            authQueryError: "",
        };
    },
    computed: {
        isAuthOperator() {
            const u = this.userinfo;
            if (!u || u.id === undefined || u.id === null) return false;
            return Number(u.id) === 4;
        },
        authApplyStatus() {
            if (!this.authQuery || this.authQuery.apply_status == null || this.authQuery.apply_status === "") {
                return null;
            }
            return Number(this.authQuery.apply_status);
        },
        isAuthRefill() {
            return this.authApplyStatus === 3;
        },
        authApplyStatusMeta() {
            const m = {
                0: { label: "审核单不存在", type: "info" },
                1: { label: "待支付", type: "warning" },
                2: { label: "审核中", type: "warning" },
                3: { label: "打回重填", type: "error" },
                4: { label: "认证通过", type: "success" },
                5: { label: "认证最终失败", type: "error" },
            };
            if (this.authApplyStatus == null) return null;
            return m[this.authApplyStatus] || { label: `状态 ${this.authApplyStatus}`, type: "info" };
        },
        authRefillReason() {
            if (!this.authQuery) return "";
            return String(this.authQuery.refill_reason || this.micoapplist.taskmsg || "").trim();
        },
        authFailReason() {
            if (!this.authQuery) return "";
            return String(this.authQuery.fail_reason || this.micoapplist.taskmsg || "").trim();
        },
        /** 代理认证提交受限时的提示文案，空字符串表示可提交 */
        authSubmitBlockedReason() {
            if (this.isAuthRefill) return "";
            const r = Number(this.micoapplist.realname);
            if (r === 2) {
                return "认证审核进行中，无法重复提交";
            }
            // 认证失败时可重新发起，不因仍较久才到期而拦截
            if (r === 3) {
                return "";
            }
            const days = this.getDaysUntilAuthExpiry();
            if (days != null && days > 30) {
                return "距离认证到期仍超过30天，请在到期前30天内再发起代理认证";
            }
            return "";
        },
        /** 是否展示表单：首次提交，或微信打回重填 */
        showMicoappAuthForm() {
            if (this.isAuthRefill) return true;
            return !this.micoapplist.realnameid && !this.authSubmitBlockedReason;
        },
        showAuthWaiting() {
            return !!(this.micoapplist.realnameid && !this.showMicoappAuthForm);
        },
        isTrademarkNaming() {
            return String(this.micoappauth.account_name_type) === "2";
        },
        trademarkCertMediaIds() {
            return (this.trademarkMediaIds || [])
                .map((id) => String(id || "").trim())
                .filter(Boolean);
        },
        trademarkSlotCount() {
            let last = -1;
            (this.trademarkMediaIds || []).forEach((id, i) => {
                if (String(id || "").trim() || this.trademarkPreviews[i]) {
                    last = i;
                }
            });
            return Math.min(5, Math.max(1, last + 2));
        },
    },
    watch: {
        "micoappauth.account_name_type"(val, oldVal) {
            if (String(val) === "2") {
                if (!String(this.micoappauth.auth_identification || "").trim() && this.micoappauth.account_name) {
                    this.micoappauth.auth_identification = this.micoappauth.account_name;
                }
                return;
            }
            if (String(oldVal) === "2") {
                this.clearTrademarkMaterials();
            }
        },
        "$route.params.appid"(newId) {
            if (newId && newId !== this.appid) {
                this.appid = newId;
                this.setBreadcrumb();
                this.resetMicoappAuthForm();
                this.authQuery = null;
                this.authQueryError = "";
                this.getmicoappinfo();
            }
        },
    },
    mounted() {
        try {
            this.userinfo = JSON.parse(localStorage.getItem("user") || "null") || {};
        } catch (e) {
            this.userinfo = {};
        }
        this.appid = this.$route.params.appid;
        this.setBreadcrumb();
        this.getmicoappinfo();
    },
    methods: {
        setBreadcrumb() {
            this.items = [
                { text: this.$t("menuitems.micoapp.text"), href: "/" },
                { text: this.$t("menuitems.icp.micoapp.list"), href: "/micoapp" },
                { text: this.$t("menuitems.icp.micoapp.info"), href: `/micoapp/${this.appid}` },
                {
                    text: "小程序管理",
                    href: `/micoapp/${this.appid}#micoapp-wechat-mgmt`,
                },
                { text: "认证服务", active: true },
            ];
        },
        getmicoappinfo() {
            const that = this;
            if (!that.appid) return;
            that.loading = true;
            that.$axios
                .post(
                    "https://api.aicoiot.com/micoappapi.php",
                    {
                        action: "micoapp.info",
                        appid: that.appid,
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    that.micoapplist = response.data.data || {};
                    that.syncMicoappAuthAccountName();
                    return that.fetchLatestAuthStatus();
                })
                .catch(function (error) {
                    console.log(error);
                    that.authQuery = null;
                    that.authQueryError = "";
                })
                .finally(function () {
                    that.loading = false;
                });
        },
        /** 用 realnameid 调微信 queryauth，刷新最新审核状态 */
        fetchLatestAuthStatus() {
            const that = this;
            const taskid = that.micoapplist && that.micoapplist.realnameid;
            if (!taskid) {
                that.authQuery = null;
                that.authQueryError = "";
                return Promise.resolve();
            }
            return that.$axios
                .post(
                    "https://api.aicoiot.com/componentapi.php",
                    {
                        action: "checkauthstatus",
                        appid: that.appid,
                        taskid: taskid,
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    const data = (response && response.data) || {};
                    if (data.errcode != null && Number(data.errcode) !== 0) {
                        that.authQuery = null;
                        that.authQueryError = data.errmsg || "查询认证进度失败";
                        return;
                    }
                    that.authQuery = data;
                    that.authQueryError = "";
                    if (data.auth_url) {
                        that.micoapplist.auth_url = data.auth_url;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    that.authQuery = null;
                    that.authQueryError = (error && error.message) || "查询认证进度失败";
                });
        },
        micoappAuthQrImgUrl(url) {
            if (!url) return "";
            return "https://payapi.aic.pet/qr.png?data=" + encodeURIComponent(url);
        },
        resetMicoappAuthForm() {
            this.micoappauth = {
                customer_type: "",
                contact_info: { name: "", email: "", mobile: "" },
                qualification: "",
                account_name: "",
                account_name_type: "1",
                auth_identification: "",
                auth_ident_material: "",
            };
            this.uploadingimg.micoappauth_upload = "";
            this.clearTrademarkMaterials();
        },
        clearTrademarkMaterials() {
            this.micoappauth.auth_identification = "";
            this.micoappauth.auth_ident_material = "";
            this.trademarkPreviews = ["", "", "", "", ""];
            this.trademarkMediaIds = ["", "", "", "", ""];
            this.trademarkUploading = [false, false, false, false, false];
        },
        syncMicoappAuthAccountName() {
            if (this.micoapplist && this.micoapplist.niconame) {
                this.micoappauth.account_name = this.micoapplist.niconame;
            }
        },
        /** 距离认证过期剩余天数；无有效到期时间则返回 null */
        getDaysUntilAuthExpiry() {
            const val = this.micoapplist.endtime;
            if (val === null || val === undefined || val === "" || val == 0) return null;
            const num = Number(val);
            if (isNaN(num)) return null;
            const ms = num < 10000000000 ? num * 1000 : num;
            const end = new Date(ms);
            if (isNaN(end.getTime())) return null;
            return (end.getTime() - Date.now()) / 86400000;
        },
        getBase64(file) {
            return new Promise(function (resolve, reject) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onerror = reject;
                reader.onloadend = function () {
                    resolve(reader.result);
                };
            });
        },
        micoappauthUpload(file) {
            if (this.isUploadingAuth || !file.raw) return;
            this.isUploadingAuth = true;
            this.getBase64(file.raw)
                .then((res) => {
                    const params = res.split(",");
                    if (params.length > 1) {
                        this.uploadingimg.micoappauth_upload = params[0] + "," + params[1];
                        return this.uploadMicoappAuthCert(params[1]).then((mediaId) => {
                            this.micoappauth.qualification = mediaId;
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error("营业执照上传或处理失败，请重试");
                })
                .finally(() => {
                    this.isUploadingAuth = false;
                });
        },
        uploadMicoappAuthImage(uri, field) {
            const that = this;
            return that.$axios
                .post(
                    "https://api.aicoiot.com/componentapi.php",
                    {
                        action: "updatewaximage",
                        appid: that.appid,
                        uri: uri,
                        field: field,
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    const data = (response && response.data) || {};
                    const mid = data.media_id;
                    if (!mid) {
                        return Promise.reject(new Error(data.errmsg || "上传失败，未返回 media_id"));
                    }
                    return mid;
                });
        },
        uploadMicoappAuthCert(uri) {
            return this.uploadMicoappAuthImage(uri, "micoappauth_cert");
        },
        uploadMicoappAuthMedia(uri, field) {
            const that = this;
            return that.$axios
                .post(
                    "https://api.aicoiot.com/componentapi.php",
                    {
                        action: "upload_media_image",
                        appid: that.appid,
                        uri: uri,
                        field: field,
                    },
                    {
                        headers: { Openid: that.userinfo.openid },
                    }
                )
                .then(function (response) {
                    const data = (response && response.data) || {};
                    const mid = data.media_id;
                    if (!mid) {
                        return Promise.reject(new Error(data.errmsg || "上传失败，未返回 media_id"));
                    }
                    return mid;
                });
        },
        validateAuthImageFile(raw) {
            if (!raw) return false;
            if (raw.size > 2 * 1024 * 1024) {
                this.$message.warning("图片大小不能超过 2MB");
                return false;
            }
            return true;
        },
        micoappauthTrademarkUpload(file, index) {
            const idx = Number(index);
            if (idx < 0 || idx > 4 || this.trademarkUploading[idx] || !file.raw) {
                return;
            }
            if (!this.validateAuthImageFile(file.raw)) return;
            this.$set(this.trademarkUploading, idx, true);
            this.getBase64(file.raw)
                .then((res) => {
                    const params = String(res).split(",");
                    if (params.length > 1) {
                        this.$set(this.trademarkPreviews, idx, params[0] + "," + params[1]);
                        return this.uploadMicoappAuthMedia(params[1], "micoappauth_trademark_" + (idx + 1)).then(
                            (mediaId) => {
                                this.$set(this.trademarkMediaIds, idx, mediaId);
                                this.micoappauth.auth_ident_material = this.trademarkCertMediaIds;
                                this.$message.success("商标注册证书已上传");
                            }
                        );
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error((err && err.message) || "商标注册证书上传失败，请重试");
                })
                .finally(() => {
                    this.$set(this.trademarkUploading, idx, false);
                });
        },
        micoappauthpaperAgree() {
            this.micoappauthpaper = false;
            this.micoappauth_agree = true;
        },
        goDetail() {
            this.$router.push({ path: `/micoapp/${this.appid}` });
        },
        async submitMicoappAuth() {
            if (this.authSubmitBlockedReason) {
                this.$message.warning(this.authSubmitBlockedReason);
                return;
            }
            if (!this.micoappauth_agree) {
                this.$message.warning("请先阅读并同意认证服务协议");
                return;
            }
            if (!this.micoappauth.customer_type) {
                this.$message.warning("请选择主体类型");
                return;
            }
            if (!this.micoappauth.contact_info.name || !this.micoappauth.contact_info.email) {
                this.$message.warning("请填写联系人名称与邮箱");
                return;
            }
            const mobile = String(this.micoappauth.contact_info.mobile || "").trim();
            if (!mobile) {
                this.$message.warning("请填写联系人手机号");
                return;
            }
            if (!/^1\d{10}$/.test(mobile)) {
                this.$message.warning("请填写正确的11位手机号");
                return;
            }
            this.micoappauth.contact_info.mobile = mobile;
            if (String(this.micoappauth.customer_type) !== "15" && !this.micoappauth.qualification) {
                this.$message.warning("请上传营业执照");
                return;
            }
            if (!this.micoappauth.account_name) {
                this.$message.warning("请填写小程序名称");
                return;
            }
            if (this.isTrademarkNaming) {
                const trademarkName = String(this.micoappauth.auth_identification || "").trim();
                if (!trademarkName) {
                    this.$message.warning("请填写商标名称");
                    return;
                }
                this.micoappauth.auth_identification = trademarkName;
                if (!this.trademarkCertMediaIds.length) {
                    this.$message.warning("请上传商标注册证书");
                    return;
                }
            }
            this.authSubmitLoading = true;
            try {
                const from = {
                    ...this.micoappauth,
                    contact_info: { ...this.micoappauth.contact_info },
                };
                if (this.isTrademarkNaming) {
                    const ids = this.trademarkCertMediaIds;
                    from.auth_ident_material = ids;
                    from.account_supplemental = ids;
                } else {
                    from.auth_identification = "";
                    from.auth_ident_material = "";
                }
                const payload = {
                    action: "wxa_submit_audit",
                    appid: this.appid,
                    from,
                };
                if (this.isAuthRefill && this.micoapplist.realnameid) {
                    payload.taskid = this.micoapplist.realnameid;
                }
                const res = await this.$axios.post(
                    "https://api.aicoiot.com/componentapi.php",
                    payload,
                    {
                        headers: { Openid: this.userinfo.openid },
                    }
                );
                const response = res.data;
                if (response && Number(response.status) === 200 && response.auth_url) {
                    this.authQrcodeDataUrl = response.auth_url;
                    this.authQrcodeDialogVisible = true;
                    this.getmicoappinfo();
                } else {
                    this.$alert((response && response.errmsg) || "提交失败", "提示", {
                        confirmButtonText: "确定",
                    });
                }
            } catch (e) {
                console.error(e);
                this.$message.error("提交认证请求失败");
            } finally {
                this.authSubmitLoading = false;
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page micoapp-auth-page" v-loading="loading">
            <div class="row">
                <div class="col-12">
                    <div class="card micoapp-info-card">
                        <div class="card-body">
                            <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                                <h6 class="micoapp-info-card-title mb-0">微信代理认证</h6>
                                <div>
                                    <el-button size="small" @click="goDetail">返回小程序详情</el-button>
                                    <el-button type="primary" size="small" :loading="loading" @click="getmicoappinfo">
                                        刷新
                                    </el-button>
                                </div>
                            </div>
                            <el-alert
                                v-if="!isAuthOperator"
                                type="warning"
                                title="当前登录账号无权限使用代理认证功能"
                                description="仅指定运营账号可操作，如有需要请联系管理员。"
                                :closable="false"
                                show-icon
                                class="mb-3"
                            />
                            <template v-else-if="micoapplist.appid">
                                <div v-loading="authSubmitLoading">
                                    <el-alert
                                        v-if="authQueryError"
                                        type="error"
                                        :title="authQueryError"
                                        :closable="false"
                                        show-icon
                                        class="mb-3"
                                    />
                                    <el-alert
                                        v-else-if="authApplyStatusMeta"
                                        :type="authApplyStatusMeta.type"
                                        :title="'最新认证状态：' + authApplyStatusMeta.label"
                                        :description="authApplyStatus === 3 ? authRefillReason : (authApplyStatus === 5 ? authFailReason : '')"
                                        :closable="false"
                                        show-icon
                                        class="mb-3"
                                    />
                                    <el-alert
                                        v-if="authSubmitBlockedReason"
                                        type="warning"
                                        :title="authSubmitBlockedReason"
                                        :closable="false"
                                        show-icon
                                        class="mb-3"
                                    />
                                    <el-form
                                        v-if="showMicoappAuthForm"
                                        ref="micoappAuthForm"
                                        label-width="120px"
                                        class="micoapp-auth-form"
                                    >
                                        <el-form-item label="主体类型">
                                            <el-select v-model="micoappauth.customer_type" placeholder="请选择" clearable>
                                                <el-option label="企业" value="1"></el-option>
                                                <el-option label="个体工商" value="12"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <template v-if="micoappauth.customer_type">
                                            <el-form-item label="联系人名称">
                                                <el-input v-model="micoappauth.contact_info.name" placeholder="联系人姓名"></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系人邮箱">
                                                <el-input v-model="micoappauth.contact_info.email" placeholder="联系人邮箱"></el-input>
                                            </el-form-item>
                                            <el-form-item label="联系人手机">
                                                <el-input
                                                    v-model="micoappauth.contact_info.mobile"
                                                    maxlength="11"
                                                    placeholder="11位手机号"
                                                ></el-input>
                                                <span class="text-muted small d-block mt-1">微信要求打回重填时可修改认证联系人手机号</span>
                                            </el-form-item>
                                            <el-form-item
                                                v-if="String(micoappauth.customer_type) !== '15'"
                                                label="营业执照"
                                            >
                                                <el-upload
                                                    class="micoapp-auth-uploader"
                                                    action="#"
                                                    accept=".jpg,.jpeg"
                                                    :show-file-list="false"
                                                    :auto-upload="false"
                                                    :on-change="micoappauthUpload"
                                                >
                                                    <div class="micoapp-auth-upload-box">
                                                        <img
                                                            v-if="uploadingimg.micoappauth_upload"
                                                            :src="uploadingimg.micoappauth_upload"
                                                            class="micoapp-auth-upload-preview"
                                                            alt="营业执照预览"
                                                        />
                                                        <div v-else class="micoapp-auth-upload-empty">
                                                            <i class="el-icon-plus"></i>
                                                            <span>点击上传营业执照</span>
                                                        </div>
                                                        <div
                                                            v-if="uploadingimg.micoappauth_upload"
                                                            class="micoapp-auth-upload-mask"
                                                        >
                                                            重新上传
                                                        </div>
                                                    </div>
                                                </el-upload>
                                                <span class="text-muted small d-block mt-1">仅支持 JPG，预览为缩略图</span>
                                            </el-form-item>
                                            <el-form-item label="小程序名称">
                                                <el-input v-model="micoappauth.account_name" placeholder="默认同步当前小程序名称"></el-input>
                                            </el-form-item>
                                            <el-form-item label="名称命名类型">
                                                <el-radio v-model="micoappauth.account_name_type" label="1">基于自选词汇</el-radio>
                                                <el-radio v-model="micoappauth.account_name_type" label="2">基于商标</el-radio>
                                                <span class="text-muted small d-block mt-1">基于商标命名时，小程序名称须与商标注册证上的名称一致，并上传注册证书</span>
                                            </el-form-item>
                                            <template v-if="isTrademarkNaming">
                                                <el-form-item label="商标名称">
                                                    <el-input
                                                        v-model="micoappauth.auth_identification"
                                                        placeholder="须与商标注册证上的商标名称一致"
                                                    ></el-input>
                                                </el-form-item>
                                                <el-form-item label="商标注册证书">
                                                    <div class="micoapp-auth-trademark-row">
                                                        <el-upload
                                                            v-for="n in trademarkSlotCount"
                                                            :key="'trademark-cert-' + n"
                                                            class="micoapp-auth-uploader"
                                                            action="#"
                                                            accept=".jpg,.jpeg,.png"
                                                            :show-file-list="false"
                                                            :auto-upload="false"
                                                            :disabled="trademarkUploading[n - 1]"
                                                            :on-change="(file) => micoappauthTrademarkUpload(file, n - 1)"
                                                        >
                                                            <div class="micoapp-auth-upload-box micoapp-auth-upload-box--sm">
                                                                <img
                                                                    v-if="trademarkPreviews[n - 1]"
                                                                    :src="trademarkPreviews[n - 1]"
                                                                    class="micoapp-auth-upload-preview"
                                                                    alt="商标注册证书预览"
                                                                />
                                                                <div v-else class="micoapp-auth-upload-empty">
                                                                    <i class="el-icon-plus"></i>
                                                                    <span>{{ n === 1 ? "点击上传注册证书" : "补充页 " + n }}</span>
                                                                </div>
                                                                <div
                                                                    v-if="trademarkPreviews[n - 1]"
                                                                    class="micoapp-auth-upload-mask"
                                                                >
                                                                    {{ trademarkUploading[n - 1] ? "上传中" : "重新上传" }}
                                                                </div>
                                                            </div>
                                                        </el-upload>
                                                    </div>
                                                    <span class="text-muted small d-block mt-1">支持 JPG/PNG，单张不超过 2MB，最多 5 张（正本、续展或变更页）</span>
                                                </el-form-item>
                                            </template>
                                            <el-form-item>
                                                <el-link type="primary" @click="micoappauthpaper = true">查看《微信公众平台代理认证服务协议》</el-link>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-button
                                                    type="primary"
                                                    :loading="authSubmitLoading"
                                                    :disabled="!micoappauth_agree"
                                                    @click="submitMicoappAuth"
                                                >
                                                    {{ isAuthRefill ? "重新提交" : "提交" }}
                                                </el-button>
                                                <el-button
                                                    v-if="!micoappauth_agree"
                                                    type="text"
                                                    @click="micoappauthpaper = true"
                                                >
                                                    去同意协议
                                                </el-button>
                                            </el-form-item>
                                        </template>
                                    </el-form>
                                    <div
                                        v-else-if="showAuthWaiting"
                                        class="micoapp-auth-submitted"
                                    >
                                        <p class="micoapp-auth-submitted-tip">
                                            {{ authApplyStatus === 4 ? "认证已通过" : (authApplyStatus === 5 ? "认证最终失败，无法再修改" : "您已完成认证提交，请使用微信扫描下方二维码，等待认证结果") }}
                                        </p>
                                        <div v-if="micoapplist.auth_url" class="micoapp-auth-qr-wrap">
                                            <img
                                                :src="micoappAuthQrImgUrl(micoapplist.auth_url)"
                                                alt="认证二维码"
                                                class="micoapp-auth-wait-qr"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="微信公众平台代理认证服务协议"
            :visible.sync="micoappauthpaper"
            width="60%"
            append-to-body
        >
            <div class="micoapp-auth-paper">
                申请微信认证是一项严肃的法律行为，拟认证主体特此申请微信（公众号/小程序/开放平台）账号（APPID）
                <strong>{{ micoapplist.appid }}</strong>
                认证服务，已仔细阅读并同意以下内容及
                <a
                    href="https://mp.weixin.qq.com/cgi-bin/readtemplate?t=home/deal_approve_tmpl&type=info&lang=zh_CN"
                    target="_blank"
                    rel="noopener noreferrer"
                >《微信公众平台认证服务协议》</a>。
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="micoappauthpaper = false">取消</el-button>
                <el-button type="primary" @click="micoappauthpaperAgree">同意</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="微信扫码完成认证"
            :visible.sync="authQrcodeDialogVisible"
            width="280px"
            append-to-body
        >
            <div class="micoapp-auth-qr-wrap">
                <img
                    v-if="authQrcodeDataUrl"
                    :src="micoappAuthQrImgUrl(authQrcodeDataUrl)"
                    alt="认证二维码"
                    class="micoapp-auth-submit-qr"
                />
            </div>
        </el-dialog>
    </Layout>
</template>

<style scoped>
.micoapp-info-card {
    margin-bottom: 1.5rem;
}

.micoapp-info-card-title {
    font-weight: 600;
    color: #374151;
    margin: 0 0 1rem 0;
    font-size: 1rem;
}

.micoapp-auth-paper {
    line-height: 1.65;
    color: #374151;
}

.micoapp-auth-form {
    max-width: 780px;
}

.micoapp-auth-submitted {
    text-align: center;
    padding: 8px 0 16px;
}

.micoapp-auth-submitted-tip {
    margin: 0 0 16px;
    color: #606266;
    line-height: 1.6;
}

.micoapp-auth-qr-wrap {
    display: inline-block;
    padding: 10px;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
}

.micoapp-auth-wait-qr,
.micoapp-auth-submit-qr {
    display: block;
    width: 180px;
    height: 180px;
    max-width: 180px;
    object-fit: contain;
}

::v-deep .micoapp-auth-uploader .el-upload {
    display: block;
    border: none;
    line-height: 0;
}

.micoapp-auth-trademark-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.micoapp-auth-upload-box {
    position: relative;
    width: 160px;
    height: 160px;
    border: 1px dashed #c0c4cc;
    border-radius: 8px;
    background: #f8fafc;
    overflow: hidden;
    cursor: pointer;
}

.micoapp-auth-upload-box:hover {
    border-color: #409eff;
    background: #f0f7ff;
}

.micoapp-auth-upload-box--sm {
    width: 120px;
    height: 120px;
}

.micoapp-auth-upload-box--sm .micoapp-auth-upload-preview {
    width: 120px;
    height: 120px;
}

.micoapp-auth-upload-empty {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #909399;
}

.micoapp-auth-upload-empty i {
    font-size: 28px;
    margin-bottom: 8px;
    color: #909399;
}

.micoapp-auth-upload-empty span {
    font-size: 12px;
    line-height: 1.4;
}

.micoapp-auth-upload-preview {
    display: block;
    width: 160px;
    height: 160px;
    object-fit: contain;
    background: #fff;
}

.micoapp-auth-upload-mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    color: #fff;
    text-align: center;
    background: rgba(0, 0, 0, 0.45);
}
</style>
